import { Flame, Zap } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

interface CourseCardDealIconProps {
  flashDeal?: boolean;
  cyberActive?: boolean;
  hasDiscount?: boolean;
  className?: string;
}

export function CourseCardDealIcon({
  flashDeal,
  cyberActive,
  hasDiscount,
  className,
}: CourseCardDealIconProps) {
  const showCyber = Boolean(cyberActive && hasDiscount);
  const showFlash = !showCyber && Boolean(flashDeal);

  if (!showCyber && !showFlash) return null;

  const label = showCyber ? 'Cyber' : 'Oferta flash';
  const Icon = showCyber ? Flame : Zap;

  return (
    <span
      aria-label={label}
      className={cn(
        'text-(--course-deal) inline-flex shrink-0 items-center justify-center self-center',
        className,
      )}
      role="img"
      title={label}
    >
      <Icon aria-hidden="true" className="h-4 w-4" fill="currentColor" strokeWidth={2.2} />
    </span>
  );
}
